'use client'

import { ComponentProps } from 'react'

import { TRoomDetail } from '@/entities/room'

import { ActionButtons } from './action-buttons'
import * as Contract from './contract-information'
import { ContractActionArea } from '../contract-action-area'
import { ContractFee, MinimumContractPeriod } from '../contract-fee'
import { DiscountInformation } from '../discount-information'

type Props = ComponentProps<'div'> & {
  room: Pick<
    TRoomDetail,
    | 'rid'
    | 'roomUrl'
    | 'like'
    | 'usingFee'
    | 'mgmtFee'
    | 'minimumContractWeeks'
    | 'longTermDiscounts'
    | 'earlyCheckinDiscounts'
    | 'roomName'
    | 'propertyType'
    | 'state'
    | 'province'
  >
  pageType?: 'detail' | 'preview' | 'contract'
  onShared?: () => void
}

export const SidePanel = ({
  room,
  pageType = 'detail',
  onShared,
  ref,
  ...props
}: Props) => {
  const showLikeButton = pageType === 'detail'
  const isContractDisabled = pageType !== 'detail'

  return (
    <div
      className="h-fit w-[330px] rounded-sm bg-white py-7.5 shadow-[0px_1px_7px_0px_rgba(0,0,0,0.15)]"
      ref={ref}
      {...props}
    >
      <div className="mb-3 flex justify-between px-6">
        <MinimumContractPeriod
          minimumContractWeeks={room.minimumContractWeeks}
        />
        <ActionButtons
          roomId={room.rid}
          like={room.like}
          showLikeButton={showLikeButton}
          roomUrl={room.roomUrl}
          onShared={onShared}
        />
      </div>
      <ContractFee usingFee={room.usingFee} mgmtFee={room.mgmtFee} />
      <DiscountInformation
        longTermDiscounts={room.longTermDiscounts}
        earlyCheckinDiscounts={room.earlyCheckinDiscounts}
      />
      <Contract.Provider roomId={room.rid}>
        <Contract.Container>
          <Contract.PeriodButton />
          <Contract.PriceInformation roomId={room.rid} />
        </Contract.Container>
        <ContractActionArea roomId={room.rid} disabled={isContractDisabled} />
      </Contract.Provider>
    </div>
  )
}
